// extracted by mini-css-extract-plugin
export default {"base":"contact-item-module--base--U+xex","icon":"contact-item-module--icon--izuMH"};